import { connect } from "react-redux";
import AnalysisHeader from './AnalysisHeader';

// Every fetch*Api slice that feeds the filters/charts this page renders — the
// PDF preview snapshots that same content, so the button stays disabled until
// all of them have settled. Connected here (rather than in BenchmarkAnalysis)
// so a slice flipping isProcessing only re-renders this header, not the whole
// page.
const BENCHMARK_API_KEYS = [
    'fetchSurveyLists',
    'fetchOrgRaterGroupsApi',
    'fetchBenchmarkKpiTilesApi',
    'fetchTotalFeedbackProvidersApi',
    'fetchTotalFeedbackProvidersStrengthAndDevApi',
    'fetchTopStrengthAndTopDevApi',
    'fetchRaterHeatmapApi',
    'fetchSelfVsOthersApi',
    'fetchDistributionStripApi',
    'fetchRankDeltaApi',
    'fetchCantAnswerResponseApi',
    'fetchCommentsAndGistApi',
];

const mapStateToProps = (state) => ({
    apiLoading: BENCHMARK_API_KEYS.some(
        (key) => !!(state.BenchmarkFilteringReducer[key] && state.BenchmarkFilteringReducer[key].isProcessing)
    ),
});

export default connect(mapStateToProps)(AnalysisHeader);
